// extracted by mini-css-extract-plugin
module.exports = {"sp_items":"StartProjectItems_sp_items__2aNBE","sp_items__title":"StartProjectItems_sp_items__title__3p5EW"};